import { Component, ViewContainerRef, TemplateRef, ElementRef, ViewChild  } from '@angular/core';
import { Sales } from '../../models/sales/sales.model';
import { SaleCategories } from '../../models/sales/sales.model';
import { SaleProducts } from '../../models/sales/sales.model';
import { CategoryService } from '../../services/category/category.service';
import { Category } from '../../models/category/category.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Notification } from '../../models/notification/notification.model';
import { NotificationService } from '../../services/notification/notification.service';
import { Payment } from '../../models/payment/payment-model';
import { PaymentService } from '../../services/payment/payment.service';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Router, Data } from "@angular/router";
import { ProductService } from '../../services/product/product.service';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { forEach } from '@angular/router/src/utils/collection';
import { CookieService } from 'ngx-cookie-service';
import { DragulaService } from 'ng2-dragula';


@Component({
  selector: 'app-category-sales',
  templateUrl: './category-sales.component.html',
  styleUrls: ['./category-sales.component.css']
})
/** category-sales component*/
export class CategorySalesComponent {
  isFileDownload: boolean;
  @ViewChild('fileDownload') fileDownload: ElementRef;
  public startDateElement: any;
  public endDateElement: any;
  public sales = new Sales();
  isFileUpload: boolean;
  productsList: SaleProducts[];
  public saleCategories = new SaleCategories();
  public saleProduct = new SaleProducts();
  Criteria: boolean;
  ProductExist: boolean;
  parentCategory: boolean;
  selectedSaleLogo: string;
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public subcategoryList: Category[];
  public notification = new Notification();
  public paymentList: Payment[];
  salesType: number;
  compnaylevel: boolean;
  categorylevel: boolean;
  paymentlevel: boolean;
  isSubmit: boolean;
  saleID: number;
  public showSuggestions: boolean;
  urls = new Array<string>();
  files: any;
  public progress: number;
  public message: string;
  saleCategoryList: SaleCategories[] = [];
  saleProductList: SaleProducts[] = [];
  public ExportProductList: SaleProducts[];
  fileToUpload: File;
  public mediaList: MediaLibrary[];
  mediaImageShow: boolean;
  public showProductPercent: boolean = false;
  public showProductFixed: boolean = true;
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  regDate: Date;
  endRegDate: Date;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  userId: number;
  public bulkProduct: any;
  public Importfiles: boolean = false;
  public FormDataFile: FormData;
  /** category-sales ctor */
  constructor(private http: HttpClient, private dragulaService: DragulaService, private readonly paymentService: PaymentService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly categoryService: CategoryService, private router: Router,
    private readonly notificationService: NotificationService, private readonly productService: ProductService, private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService, private readonly rolePermissionService: RolePermissionService, private cookieService: CookieService) {
    this.isFileDownload = true;
    this.isFileUpload = false;
    this.Importfiles = false;
    try {
      this.dragulaService.destroy("VAMPIRES");
    } catch (e) {
    }
    this.dragulaService.createGroup("VAMPIRES", {

    });
    this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
    });
    this.rolePermissionService.GetRolePermissions("categorysale").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.salesType = 1;
            this.ProductExist = false;
            this.compnaylevel = true;
            this.categorylevel = false;
            this.paymentlevel = false;
            this.sales.domainType = 1;
            this.Criteria = false;
            this.parentCategory = false;
           // this.saleCategories.criteria = 0;
            this.sales.isActive = true;
            //this.sales.dicsountPercent = 0;
            this.saleProduct.discountType = null;
            this.saleProductList = [];
            this.saleCategoryList = [];
            this.isSubmit = true;
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
    // this.getProducts();
          }
          else {
            this.router.navigate(["/sale-list"]);
          }
        }
        else {
          this.router.navigate(["/sale-list"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.endRegDate = new Date();
    this.regDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.mediaImageShow = true;
    this.selectedSaleLogo = "";
    this.sales.saleLogo = "";
    this.sales.saleLogo = Image.fileName;

    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.mediaImageShow = false;
    this.selectedSaleLogo = "";
    this.modalRef.hide();
  }
  HidePopup() {
    this.selectedSaleLogo = "";
    this.sales.saleLogo = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  genrateColumns(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);
    this.FormDataFile = formData;
    this.Importfiles = true;
  }
  ImportProducts() {
    if (!this.Importfiles) {
      this.toastr.error("Please Select File", 'Error');
      return;
    }
    this.isFileUpload = true;
    this.productService.SaleProductUpload(this.FormDataFile).subscribe(
      data => {
        this.saleProductList = data;

        for (var i = 0; i < this.saleProductList.length; i++) {
          if (this.saleProductList[i].venderParticipation == 0) {
            this.saleProductList[i].disable = true;
          }
          if (this.saleProductList[i].discountType == 1) {
            this.saleProductList[i].showProductPercent = true;
          }
          else {
            this.saleProductList[i].showProductFixed = true;
          }
          //else {
          //  this.saleProductList[i].disable = true;
          //}
        }


        if (this.saleProductList.length > 0) {
          this.toastr.success("Products Upload Successfully", 'Success');
          this.isFileUpload = false;
        }
      });
  }
  exportProducts() {
    if (this.saleProductList == null || this.saleProductList.length <= 0) {
      this.toastr.info("No Products to Export", 'Info');
      this.isFileDownload = true;
    }
    else {
      if (this.isFileDownload) {
        this.isFileDownload = false;
        this.ExportProductList = this.saleProductList;
        this.productService.ExportSaleProducts(this.ExportProductList).subscribe(
          data => {
            if (data.status == 1) {
              var path = data.data;
              window.open("/Files/" + path);
              //this.fileDownload.nativeElement.href = ;
              //this.fileDownload.nativeElement.click();
              this.toastr.success(data.message, 'Success');
              this.isFileDownload = true;
            }
            else {
              this.toastr.error(data.message, 'Error');
              this.isFileDownload = true;
            }
          })
      }

    }
  }
  SearchProduct() {
    this.bulkProduct;
    if (this.bulkProduct != "") {
      this.productService.ProductBulk(this.bulkProduct).subscribe(
        data => {
          if (data)
            this.productsList = data;
          for (var i = 0; i < this.productsList.length; i++) {
            this.SelectProduct(this.productsList[i]);
          }
          this.bulkProduct = "";
        });
    }
    else {
      this.toastr.error('Please Enter Product Id', 'Error');
    }
  }
  onSearch(searchText: string) {
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      this.showSuggestions = false;
      return;
    }
    if (length > 0) {
      this.productService.ProductSuggestions(searchText).subscribe(
        data => {
          this.productsList = data;
          if (this.productsList.length > 0) this.showSuggestions = true;
        });
    }
    else {
      this.productsList = [];
      this.showSuggestions = false;
    }
  }

  SelectProduct(saleProduct: SaleProducts) {
    this.saleProduct = saleProduct;
    this.saleProduct.discountType = 2;
    this.saleProduct.showProductFixed = true;
    this.saleProduct.showProductPercent = false;
    //if (!this.saleProductList.filter(y => y.productID == this.saleProduct.productID)) {
    //  this.saleProductList.push(this.saleProduct);
    //}
    if (!this.saleProductList.some((item) => item.productID == this.saleProduct.productID)) {
      this.saleProductList.push(this.saleProduct);
    }
    else {
      this.toastr.error('This item is already Exist', 'Fail!');
    }

    // this.saleProductList.push(this.saleProduct);
    this.saleProduct = new SaleProducts();
    this.ProductExist = false;
    this.showSuggestions = false;
  }

  removeProduct(cat: SaleProducts, index: number) {
    for (let i = 0; i < this.saleProductList.length; i++) {
      var obj = this.saleProductList[i];
      var check = false;

      if (obj.productID == cat.productID) {
        this.saleProductList.splice(index, 1);
        check = true;
      }
      if (check) return true;
    }

  }
  getpaymentmethods() {
    this.paymentService.getActivePaymentMethods().subscribe(
      data => {
        this.paymentList = data;
        this.sales.paymentMethodID = null;
      }
    )
  }
  ShowSection(typeid: number) {
    this.salesType = typeid;
    this.sales.saleTypeID = this.salesType;
    if (typeid == 1) {
      this.compnaylevel = true;
      this.categorylevel = false;
      this.paymentlevel = false;
    }
    else if (typeid == 2) {
      this.compnaylevel = false;
      this.categorylevel = true;
      this.paymentlevel = false;
      this.showSuggestions = false;
      this.saleCategories.parentCategoryID = null;
      this.GetCategoryList();
    }
    else if (typeid == 3) {
      this.compnaylevel = false;
      this.categorylevel = false;
      this.showSuggestions = false;
      this.paymentlevel = true;
      this.getpaymentmethods();
    }


  }
  //UploadImages(event) {
  //  this.urls = [];
  //  let files = event;
  //  this.files = files;
  //  if (files) {
  //    for (let file of files) {
  //      let reader = new FileReader();
  //      reader.onload = (e: any) => {
  //        this.urls.push(e.target.result);
  //      }
  //      reader.readAsDataURL(file);
  //    }
  //  }
  //}


  GetCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data;
        this.saleCategories.parentCategoryID = null;
        this.saleCategories.parentCategoryName = data[0].categoryName;
        this.saleCategories.categoryID = 0;
        this.saleCategories.categoryName = "All";
        this.saleCategories.subCategoryID = 0;
        this.saleCategories.subCategoryName = "All";
        //  this.GetCategoryListByParent(data[0].categoryID);
      }
    )
  }
  GetCategoryListByParent(parentCategoryId: number) {
    if (parentCategoryId > 0) {
      this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
        data => {
          this.categoryList = data;
          this.parentCategory = false;
          //   this.GetSubCategoryListByParent(data[0].categoryID);
        }
      )
      // set parent select value

      this.parentCategoryList.forEach(obj => {
        if (obj.categoryID == parentCategoryId) {
          this.saleCategories.parentCategoryID = parentCategoryId;
          this.saleCategories.parentCategoryName = obj.categoryName;
          return false;
        }
      });
    }
    else {
      this.categoryList = [];
      this.saleCategories.categoryID = 0;
      this.saleCategories.categoryName = "";
    }



  }
  GetSubCategoryListByParent(parentCategoryId: number) {
    if (parentCategoryId > 0) {
      this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
        data => {
          this.subcategoryList = data;
        }
      )
      // set parent select value

      this.categoryList.forEach(obj => {
        if (obj.categoryID == parentCategoryId) {
          this.saleCategories.categoryID = parentCategoryId;
          this.saleCategories.categoryName = obj.categoryName;
          return false;
        }
      });

    }
    else {
      this.subcategoryList = [];
      this.saleCategories.categoryID = 0;
      this.saleCategories.categoryName = "All";
    }

  }
  HideCriteriaMessage() {
    this.Criteria = false;
  }
  GetCategoryValue(CategoryId: number) {

    // set parent select value
    if (CategoryId > 0) {
      this.subcategoryList.forEach(obj => {
        if (obj.categoryID == CategoryId) {
          this.saleCategories.subCategoryID = CategoryId;
          this.saleCategories.subCategoryName = obj.categoryName;
          return false;
        }
      });

    }
    else {
      this.saleCategories.subCategoryID = 0;
      this.saleCategories.subCategoryName = "All";
    }



  }
  UploadImages(file: FileList) {
    this.fileToUpload = file.item(0);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.sales.saleLogo = "";
      this.mediaImageShow = true;
      this.selectedSaleLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  upload() {
    try {
      if (typeof this.fileToUpload == "undefined") {

        this.toastr.success('Sale has been Saved.', 'Success!');
        setTimeout(() => {
          this.router.navigate(["/sale-list"]);
        }, 2000);
      }
    } catch (e) {
      this.toastr.success('Sale has been Saved.', 'Success!');
      setTimeout(() => {
        this.router.navigate(["/sale-list"]);
      }, 2000);
    }
    if (typeof this.fileToUpload != "undefined") {
      const formData = new FormData();
      //for (let file of this.files) formData.append(file.name, file);
      // add ProductID
      formData.append("SaleLogo", this.fileToUpload);
      formData.append("SaleID", this.saleID.toString());
      const uploadReq = new HttpRequest('POST', `api/Category/UploadFile?userId=` + this.userId, formData, {
        reportProgress: true,
        headers: new HttpHeaders({ "Token": this.cookieService.get('Login') })
      });
      this.http.request(uploadReq).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response)
          this.message = event.body.toString();

      });
      this.toastr.success('Sale has been Saved.', 'Success!');
      setTimeout(() => {
        this.router.navigate(["/sale-list"]);
      }, 2000);
    }
  }
  GetDomain(type: number) {

    this.sales.domainType = type;

  }
  addCategory() {
    if (this.saleCategories.criteria > 0 && this.saleCategories.parentCategoryID > 0) {
      this.Criteria = false;
      this.parentCategory = false;
      if (this.saleCategories.categoryID == 0) {
        this.saleCategories.categoryID = 0;
        this.saleCategories.categoryName = "All";
      }
      if (this.saleCategories.subCategoryID == 0) {
        this.saleCategories.subCategoryID = 0;
        this.saleCategories.subCategoryName = "All";
      }
      var node = new SaleCategories();
      node = this.saleCategories;
      this.saleCategoryList.push(node);
      this.saleCategories = new SaleCategories();
      this.GetCategoryList();
    }
    else if (this.saleCategories.parentCategoryID == null) {
      this.parentCategory = true;
    }
    else {
      this.Criteria = true;
    }
  }
  removeCatgory(cat: SaleCategories, index: number) {
    for (let i = 0; i < this.saleCategoryList.length; i++) {
      var obj = this.saleCategoryList[i];
      var check = false;

      if (obj.categoryID == cat.categoryID && obj.parentCategoryID == cat.parentCategoryID && obj.subCategoryID == cat.subCategoryID) {
        this.saleCategoryList.splice(index, 1);
        check = true;
      }
      if (check) return true;
    }

  }
  selectStartDate(e) {
    if (e != null) {
    this.sales.startDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.sales.endDate = e;
      this.regDate = e;
      this.endRegDate = new Date(this.regDate);
    }
  }
  selectRegistrationDateDate(e) {
    if (e != null) {
      this.sales.applyDate = e;
    }
  }
  keyPress(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  onSubmit() {
    if (this.salesType == 2) {
      if (this.saleCategoryList.length == 0) {
        this.parentCategory = true;
        return;
      }
      else {
        var result = this.saleCategoryList.filter(x => x.criteria == null);
        result.forEach(obj => {
          if (obj.criteria == null) {
            obj.criteria = 0;
          }
        });
        this.sales.saleCategories = this.saleCategoryList;
        
         // this.saleCategoryList = [];
          
        this.parentCategory = false;
      }

    }
    if (this.salesType == 1) {
      if (this.saleProductList.length == 0) {
        this.ProductExist = true;
        return;
      }
      else {
        var result2 = this.saleProductList.filter(x => x.companyParticipation == null);
        result2.forEach(obj => {
          if (obj.companyParticipation == null) {
            obj.companyParticipation = 0;
          }
        });
        this.sales.saleProducts = this.saleProductList;      
        //  this.saleProductList = []; 
        this.ProductExist = false;
      }

    }
    this.isSubmit = false;
    //this.startDateElement = document.getElementById("startDate") as HTMLElement;
    //this.endDateElement = document.getElementById("endDate") as HTMLElement;
    this.sales.saleTypeID = this.salesType;
    //this.sales.startDate = this.startDateElement.value;
    //this.sales.endDate = this.endDateElement.value;
    //  this.sales.applyDate = this.sales.endDate;
    this.notification.notificationDetail = this.sales.description;
    this.notification.title = this.sales.title;
    this.categoryService.AddSale(this.sales).subscribe(
      data => {
        if (data > 0) {
          if (this.sales.saleTypeID != 3) {
            this.notification.eventID = 5;
            //this.notification.roleID = 1;
            this.notification.sortOrder = 0;
            this.notification.notificationType = "Header Notification";
            this.notification.isActive = true;
            this.notification.notificationDetail = this.notification.notificationDetail + " <a class='btn btn-xs btn-primary' href='/vendor-catagory-sales/" + String(data) + "]'>Click Here</a>";
            
            this.notificationService.AddSalesNotification(this.notification);
          }
          this.notification = new Notification();
          this.saleID = data;
          this.upload();
          //   this.sales = new Sales();

        }
        else {
          this.toastr.error('Unable to save', 'Fail!');
        }
      });

  }

  checkPercent(event: any) {
    if (this.sales.dicsountPercent > 100) {
      this.sales.dicsountPercent = 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      this.sales.dicsountPercent = null;
      return false;
    }
    return true;

  }
  checkPercentCriteria(event: any) {
    if (this.saleCategories.criteria > 100) {
      this.saleCategories.criteria = 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      this.saleCategories.criteria = null;
      return false;
    }
    return true;

  }
  checkPercentProduct(event: any,i:number) {
    if (this.saleProductList[i].companyParticipation > 100) {
      this.saleProductList[i].companyParticipation= 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      this.saleProductList[i].companyParticipation = null;
      return false;
    }
    return true;

  }
  setPercent(i:number) {
    if (this.saleProductList[i].discountType == 1) {
       this.saleProductList[i].showProductPercent = true;
      this.saleProductList[i].showProductFixed = false;
    }
    else {
      this.saleProductList[i].showProductPercent = false;
      this.saleProductList[i].showProductFixed = true;
    }
  }
 
  ImportProductsFile(file: FileList) {
    this.fileToUpload = file.item(0);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.sales.saleLogo = "";
      this.mediaImageShow = true;
      this.selectedSaleLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  fileChanged(event) {
  }

}



// WEBPACK FOOTER //
// ./src/app/category-components/category-sales/category-sales.component.ts